import { render, staticRenderFns } from "./SectionPointsList.vue?vue&type=template&id=63439cdc"
import script from "./SectionPointsList.vue?vue&type=script&lang=js"
export * from "./SectionPointsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports